"use strict";

export default [
  "$utils",
  "$filterUtils",
  ($utils, $filterUtils) => {
    let filters = getDefaultFilters();

    function getFilters() {
      return angular.copy(filters);
    }

    function setFilters(newFilters) {
      Object.assign(filters, angular.copy(newFilters));
    }

    function getDefaultFilters() {
      return {
        // sidebar filters
        industry: [],
        planEndYear: null,
        planStartYear: null,
        placeMunicipality: [],
        isThirdPart: null,
      };
    }

    function getAllFilters() {
      return Object.assign({}, getFilters());
    }

    function collectFilterDto(filters) {
      const filterDto = [];
      if (Array.isArray(filters.industry) && filters.industry.length) {
        filterDto.push(
          `EXTRA:'industry' EQ '${filters.industry
            .map((n) => "" + n.id)
            .join(";")}'`
        );
      }

      if (
        Array.isArray(filters.placeMunicipality) &&
        filters.placeMunicipality.length
      ) {
        filterDto.push(
          `EXTRA:'placesMunicipality' EQ '${filters.placeMunicipality
            .map((n) => "" + n.id)
            .join(";")}'`
        );
      }

      if (filters.planEndYear) {
        // Убедимся что у нас есть корректное значение года
        let year;
        if (filters.planEndYear instanceof Date) {
          year = filters.planEndYear.getFullYear();
        } else if (typeof filters.planEndYear === "number") {
          year = filters.planEndYear;
        }

        if (year) {
          filterDto.push(`'planEndYear' EQ '${year}'`);
        }
      }

      if (filters.planStartYear) {
        // Убедимся что у нас есть корректное значение года
        let year;
        if (filters.planStartYear instanceof Date) {
          year = filters.planStartYear.getFullYear();
        } else if (typeof filters.planStartYear === "number") {
          year = filters.planStartYear;
        }

        if (year) {
          filterDto.push(`'planStartYear' EQ '${year}'`);
        }
      }

      if (filters.milestone) {
        filterDto.push(`EXTRA:'milestone' NE '${filters.milestone}'`);
      }

      filterDto.push(`'entityStatus' EQ 'ENABLED'`);
      filterDto.push(`'isthirdpart' EQ 'true'`);

      return filterDto;
    }

    return {
      filters,
      setFilters,
      getFilters,
      getDefaultFilters,

      getAllFilters,

      collectFilterDto,
    };
  },
];
